import { Link } from 'react-router-dom';
import { useOperatorCompactRoute } from '@/utils/operatorCompact.js';

export default function PageHeader({ title, subtitle, actions, breadcrumbs, showBreadcrumb = false }) {
  const { isOperatorCompact } = useOperatorCompactRoute();
  const isBreadcrumbArray = Array.isArray(breadcrumbs);
  const hideTitleBlock = isOperatorCompact && !showBreadcrumb;

  if (hideTitleBlock && !actions) {
    return null;
  }

  return (
    <div className={`flex flex-col ${hideTitleBlock ? 'mb-1 gap-1 md:items-end' : 'mb-3 gap-2 md:flex-row md:items-start md:justify-between'}`}>
      <div className="min-w-0 flex-1">
        {showBreadcrumb && breadcrumbs ? (
          <nav className="mb-2 text-sm" aria-label="Breadcrumb">
            {isBreadcrumbArray ? (
              <ol className="flex flex-wrap items-center gap-2 text-[rgb(var(--muted))]">
                {breadcrumbs.map((crumb, index) => {
                  const isLast = index === breadcrumbs.length - 1;
                  const content = crumb?.href ? (
                    <Link
                      to={crumb.href}
                      className="inline-flex items-center gap-1 px-1 text-[rgb(var(--muted))] transition-colors duration-200 hover:text-[rgb(var(--brand))] focus-visible:rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <span>{crumb?.label}</span>
                  );

                  return (
                    <li
                      key={crumb?.label ?? index}
                      className={`inline-flex items-center gap-2 ${isLast ? 'text-[rgb(var(--fg))]' : 'text-[rgb(var(--muted))]'}`}
                      aria-current={isLast ? 'page' : undefined}
                    >
                      {content}
                      {!isLast ? <span aria-hidden className="text-[rgb(var(--muted))]">/</span> : null}
                    </li>
                  );
                })}
              </ol>
            ) : (
              <div className="text-[rgb(var(--muted))]">{breadcrumbs}</div>
            )}
          </nav>
        ) : null}

        {!hideTitleBlock ? (
          <>
            <h1 className="text-xl font-semibold tracking-tight text-[rgb(var(--fg))] md:text-2xl">
              {title}
            </h1>
            {subtitle ? (
              <p className="mt-1 max-w-2xl text-xs text-[rgb(var(--muted))] sm:text-sm">
                {subtitle}
              </p>
            ) : null}
          </>
        ) : null}
      </div>

      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
